import { Progress } from '@chakra-ui/react'
import { journalTemplate, minCharacters } from '../utils/constants'
import { ProgressValidationProps } from '../utils/types'

export const ProgressValidation = ({
  clinicalObservations,
  isValid,
}: ProgressValidationProps) => {
  const charactersNeededPercentage = () => {
    if (isValid) {
      return 100
    }
    return (
      ((clinicalObservations.length - journalTemplate.length) / minCharacters) *
      100
    )
  }

  const progressColor = () => {
    if (isValid) {
      return 'green'
    } else if (charactersNeededPercentage() > 70) {
      return 'cyan'
    } else if (charactersNeededPercentage() > 20) {
      return 'yellow'
    }
    return 'pink'
  }

  return (
    <Progress
      value={charactersNeededPercentage()}
      size='xs'
      colorScheme={progressColor()}
    />
  )
}
